import type { BomIntakeStagingLine } from '@/services/boms/intake'

export type BomIntakeStatusCounts = {
  OK: number
  NEEDS_MAPPING: number
  ERROR: number
}

export function computeBomIntakeStatusCounts(
  lines: Array<Pick<BomIntakeStagingLine, 'validation_status'>>,
): BomIntakeStatusCounts {
  const counts: BomIntakeStatusCounts = {
    OK: 0,
    NEEDS_MAPPING: 0,
    ERROR: 0,
  }
  for (const line of lines) {
    counts[line.validation_status] += 1
  }
  return counts
}

export type M3DeviationInfo = {
  line: BomIntakeStagingLine
  calcM3: number
  excelM3: number
  diffPercent: number
}

export type M3DeviationsResult = {
  deviatedCount: number
  deviations: M3DeviationInfo[]
}

export function computeM3Deviations(
  lines: BomIntakeStagingLine[],
): M3DeviationsResult {
  const deviations: M3DeviationInfo[] = []

  for (const l of lines) {
    if (l.line_kind !== 'wood') continue
    const raw = (l.raw_data ?? {}) as Record<string, unknown>
    const t = Number(raw.dims_finished_t)
    const w = Number(raw.dims_finished_w)
    const len = Number(raw.dims_finished_l)
    const excelM3 = Number(raw.m3_finished ?? raw.m3_piece ?? raw.m3_total)

    if (
      !Number.isFinite(t) ||
      !Number.isFinite(w) ||
      !Number.isFinite(len) ||
      t <= 0 ||
      w <= 0 ||
      len <= 0 ||
      !Number.isFinite(excelM3) ||
      excelM3 <= 0
    ) {
      continue
    }

    const calcM3 = (t * w * len) / 1e9
    const diffPercent = (Math.abs(calcM3 - excelM3) / calcM3) * 100

    if (diffPercent > 5) {
      deviations.push({
        line: l,
        calcM3,
        excelM3,
        diffPercent,
      })
    }
  }

  return {
    deviatedCount: deviations.length,
    deviations,
  }
}

